import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appAdsense]'
})
export class AdsenseDirective implements OnInit {

  @Input() adClient: string;
  @Input() adSlot: string;
  @Input() width: string = '300px';
  @Input() height: string = '250px';

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    // Clear previous content to avoid duplicate <ins> blocks
    this.el.nativeElement.innerHTML = '';

    // Create a fresh ad container
    const ins = document.createElement('ins');
    ins.className = 'adsbygoogle';
    ins.style.display = 'inline-block';
    ins.style.width = this.width;
    ins.style.height = this.height;
    ins.setAttribute('data-ad-client', this.adClient);
    ins.setAttribute('data-ad-slot', this.adSlot);

    this.el.nativeElement.appendChild(ins);

    // Ensure adsbygoogle is available and push once
    if ((window as any).adsbygoogle && Array.isArray((window as any).adsbygoogle)) {
      try {
        (window as any).adsbygoogle.push({});
      } catch (e) {
        console.error('Adsense error:', e);
      }
    }
  }
}
